<template>
  <!-- Header -->
  <div class="header">
    <!-- Logo -->
    <div class="header-left">
      <router-link to="/admin/principal" class="logo">
        <img src="@/assets/img/agv_logo.jpg" alt="Logo"  width="45" height="45" />
      </router-link>
<!--      <router-link to="/admin/principal" class="logo logo-small">-->
<!--        <img src="@/assets/img/agv_logo.jpg" alt="Logo" width="30" height="30" />-->
<!--      </router-link>-->
      <!-- Sidebar Toggle -->
      <a href="javascript:void(0);" id="toggle_btn" @click="toggleSidebar">
        <i class="feather-chevrons-left"></i>
      </a>
      <!-- /Sidebar Toggle -->

      <!-- Mobile Menu Toggle -->
      <a class="mobile_btn" id="mobile_btn" @click="toggleSidebar1">
        <i class="feather-chevrons-left"></i>
      </a>
      <!-- /Mobile Menu Toggle -->
    </div>
    <!-- /Logo -->

    <!-- /Search -->

    <!-- Header Menu -->
    <ul class="nav user-menu">
      <li class="nav-item dropdown has-arrow main-drop mt-3">
        <select 
          style="border:1px solid #6BB545; 
          font-size:12px; 
          padding: 7px; 
          border-radius: 5px; 
          background:#6BB545; 
          color:#fff"
          v-model="selectedAdminLanguage"
          >
          <option v-for="l in languages" :key="l.value" :value="l.value" style="">{{l.text}}</option>
        </select>
      </li>
      <li class="nav-item mt-3 ml-3 mr-3">
        <label>{{ usuario.username }}</label>
      </li>
      <!-- User Menu -->
      <li class="nav-item dropdown has-arrow main-drop">
        <a href="javascript:;" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
          <span class="user-img">
            <img src="@/assets/admin_img/profiles/avatar-07.jpg" alt="Image" />
            <span class="status online"></span>
          </span>
        </a>
        <div class="dropdown-menu">
          <!-- <router-link class="dropdown-item" to="/admin/profile"
            ><i class="feather feather-user me-1"></i> Mi Perfil</router-link
          > -->
          <router-link 
          class="dropdown-item" 
          to="/admin/login"
          @click="sign_out"
          >
            <i class="feather feather-log-out me-1"></i> 
            Cerrar Sesión
          </router-link>
        </div>
      </li>
      <!-- /User Menu -->
    </ul>
    <!-- /Header Menu -->
  </div>
  <!-- /Header -->
</template>

<script>
import { router } from "@/router";
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      isSidebarOpen: false,
      languages:[
        {text:'ESPAÑOL', value:'es'},
        {text:'ENGLISH', value:'en'},
      ],
      usuario: {
        nombres: '',
        username: ''
      }
    };
  },
  mounted() {
    document.addEventListener("mouseover", this.handleMouseOver);
    this.usuario = JSON.parse( localStorage.getItem("userDataAdmin") );
    // console.log("informacion del usuario", this.usuario);
  },
  beforeUnmount() {
    document.removeEventListener("mouseover", this.handleMouseOver);
  },
  computed: {
    ...mapState({
      adminLanguage: state => state.adminLanguage
    }),
    selectedAdminLanguage: {
      get() {
        return this.adminLanguage;
      },
      set(value) {
        this.changeAdminLanguage(value);
      },
    },
  },
  methods: {

    ...mapActions(['changeAdminLanguage']),

    updateLanguage(){
      this.$store.dispatch('changeLanguage', this.selectedLanguage);
    },

    toggleSidebar1() {
      const body = document.body; // Use document.body directly
      body.classList.toggle("slide-nav");
    },
    toggleSidebar() {
      const body = document.body; // Use document.body directly
      body.classList.toggle("mini-sidebar");
    },
    handleMouseOver(event) {
      event.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn"); // Use getElementById
      const sidebar = document.querySelector(".sidebar");
      const subdropUL = document.querySelectorAll(".subdrop + ul");

      if (
        body.classList.contains("mini-sidebar") &&
        getComputedStyle(toggleBtn).display !== "none" // Use getComputedStyle
      ) {
        const target = event.target.closest(".sidebar");

        if (target) {
          body.classList.add("expand-menu");
          subdropUL.forEach((ul) => {
            ul.style.display = "block";
          });
        } else {
          body.classList.remove("expand-menu");
          subdropUL.forEach((ul) => {
            ul.style.display = "none";
          });
        }

        event.preventDefault();
      }
    },
    sign_out(){
      localStorage.clear();
      router.push('/admin/login');
    }
  },
};
</script>

<style>
.header .header-left {
    width: calc(17%  + 5px); /* Aumenta el ancho actual en 20px */
}
</style>